// Trae la widget_list de un pagegrowlerList desde el back de pagegrowler.
// Se usa tanto en el API route (/api/pagegrowlerList/[...slug]) como en el
// resolver Section, para poder resolver la data server-side y evitar el
// fetch client-side que genera salto de layout (CLS).
export const getWidgetListData = async (queryUrl) => {
  try {
    const parseQueryUrl = queryUrl.filter(el => el != 'true' && el != 'false').join('/')
    const apiBase = process.env.PAGEGROWLER_FRONTEND_API ?? process.env.NEXT_PUBLIC_PAGEGROWLER_FRONTEND_API
    const url = `${apiBase}widget_list?url=/${parseQueryUrl}`

    let parseClearData = []
    const clearQuery = queryUrl[queryUrl.length - 1] === "true"

    const resWidgetList = await fetch(url);
    const jsonWidgetList = await resWidgetList.json();

    if (clearQuery) {
      parseClearData = jsonWidgetList.widgets.map(el => el.innerBoxes?.[0].subItems?.[0])
    }

    return {
      code: 200,
      data: parseClearData.length != 0 ? { widgets: parseClearData } : jsonWidgetList,
      dataP: url,
      error: null,
    };
  } catch (err) {
    return {
      code: 500,
      data: err,
      message: "Internal server error",
    }
  }
}
